import type { ThemeConfig } from 'antd';
import { theme } from 'antd';

// Vercel Design System Tokens
// Reference: https://getdesign.md/vercel/design-md

export const uvpTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Primary - Vercel Black (#171717)
    colorPrimary: '#171717',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',

    // Border Radius - Vercel scale (6px for buttons)
    borderRadius: 6,

    // Typography - Geist font family
    fontFamily:
      "Geist, -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Roboto, 'Helvetica Neue', Arial, sans-serif",

    // Colors - Light Mode
    colorBgContainer: '#ffffff',
    colorBgLayout: '#ffffff',
    colorText: '#171717',
    colorTextSecondary: '#666666',
    colorBorder: '#ebebeb',
    colorBorderSecondary: '#ebebeb',

    // Link - Vercel blue
    colorLink: '#0072f5',
    colorLinkHover: '#0a72ef',

    // Control backgrounds
    colorBgElevated: '#ffffff',
    colorBgSpotlight: 'rgba(23, 23, 23, 0.88)',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      bodyBg: '#ffffff',
    },
    Menu: {
      itemBg: '#ffffff',
      darkItemBg: '#ffffff',
      darkItemColor: '#171717',
      darkSubMenuItemBg: '#ffffff',
      subMenuItemBg: '#ffffff',
      itemColor: '#666666',
      itemHoverColor: '#171717',
      itemHoverBg: '#fafafa',
      itemSelectedColor: '#171717',
      itemSelectedBg: '#fafafa',
    },
    Button: {
      borderRadius: 6,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      borderRadius: 8,
      paddingLG: 24,
    },
    Input: {
      borderRadius: 6,
    },
    Select: {
      borderRadius: 6,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#fafafa',
      rowHoverBg: '#fafafa',
    },
    Modal: {
      borderRadius: 8,
    },
    Tag: {
      borderRadiusSM: 9999,
    },
  },
};

export const uvpDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    // Primary - Vercel Black (same in dark mode)
    colorPrimary: '#171717',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',

    // Border Radius - Vercel scale
    borderRadius: 6,

    // Typography - Geist font family
    fontFamily:
      "Geist, -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Roboto, 'Helvetica Neue', Arial, sans-serif",

    // Colors - Dark Mode (True Black)
    colorBgContainer: '#000000',
    colorBgLayout: '#000000',
    colorBgElevated: '#0a0a0a',
    colorBgSpotlight: '#0a0a0a',
    colorText: '#e0e0e0',
    colorTextSecondary: '#666666',
    colorBorder: 'rgba(255,255,255,0.1)',
    colorBorderSecondary: 'rgba(255,255,255,0.1)',

    // Link - Vercel blue
    colorLink: '#0072f5',
    colorLinkHover: '#0a72ef',
  },
  components: {
    Layout: {
      headerBg: '#000000',
      siderBg: '#000000',
      bodyBg: '#000000',
    },
    Menu: {
      itemBg: '#000000',
      darkItemBg: '#000000',
      darkItemColor: '#e0e0e0',
      darkSubMenuItemBg: '#000000',
      subMenuItemBg: '#000000',
      itemColor: '#666666',
      itemHoverColor: '#e0e0e0',
      itemHoverBg: '#171717',
      itemSelectedColor: '#ffffff',
      itemSelectedBg: '#171717',
    },
    Button: {
      borderRadius: 6,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      borderRadius: 8,
      paddingLG: 24,
    },
    Input: {
      borderRadius: 6,
    },
    Select: {
      borderRadius: 6,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#171717',
      rowHoverBg: '#0a0a0a',
    },
    Modal: {
      borderRadius: 8,
    },
    Tag: {
      borderRadiusSM: 9999,
    },
    Dropdown: {
      colorBgElevated: '#0a0a0a',
    },
  },
};
